

(function($, B) {

    B.web.onReady['fullcalendar'] = function(){

        var eventsAjax = function(fetchInfo, successCallback, failureCallback){
            var data = {
                start: fetchInfo.start.toISOString().split('T')[0], 
                end: fetchInfo.end.toISOString().split('T')[0] 
            };
            if(fetchInfo.filters){
                data.filters = fetchInfo.filters;
            }
            $.ajax({
                type : 'GET',
                url: siteAJAX.url + 'rest/calendar/get_events',       
                data: data,
                beforeSend:function(jqXHR, settings ){
                    jqXHR.setRequestHeader( 'X-WP-Nounce', siteAJAX.nounce);
                },
                success: function ( data, textStatus, jqXHR ) {
                    console.log( data );
                    successCallback(data.data.posts);
                },
                error: function(jqXHR, textStatus, errorThrown ){
                    console.log('error ajax');
                    failureCallback(errorThrown);
                }
            });           
        };
        // var getFilterValues = function($filter){
        //     var filters = {};
        //     $filter.find('[data-filter-field]').each(function(){
        //         var value = B.field.read(this, { allValue: null });
        //         if(value !== null){
        //             filters[$(this).data('filterField')] = value;
        //         }
        //         // var values = [],
        //         //     $inputs = $(this).find('input') ;
        //         // $inputs.each(function(){
        //         //     var $input = $(this);
        //         //     if($input.is(':checked')){
        //         //         values.push($input.val());
        //         //     }
        //         // });
        //         // if(values.length < $inputs.length){
        //         //     filters[$(this).data('filterField')] = values;
        //         // }
        //     });
        //     return Object.keys(filters).length > 0 ? filters : null;
        // };

        $('[data-widget="calendar"]').each(function(){
            var $calendar = $(this),
                filterSelector = '[data-filter="#' + $calendar.attr('id') + '"]',
                $filter = $(filterSelector),
                events = $calendar.data('events'),
                o = $calendar.data('widgetOptions'),
                calendar;

            calendar = new FullCalendar.Calendar(this, $.extend(true, {
                events: function(fetchInfo, successCallback, failureCallback){
                    fetchInfo.filters = B.filter.read($filter);
                    eventsAjax(fetchInfo, successCallback, failureCallback);
                },
                // themeSystem: 'bootstrap',
                locale: 'pl',
                headerToolbar: {
                    left: 'prev,next,today',
                    center: 'title',
                    right: 'dayGridMonth,dayGridWeek,listWeek,listMonth'
                },
                // themeSystem: 'bootstrap',
                navLinks: true, // can click day/week names to navigate views
                editable: false,
                dayMaxEvents: true, // allow "more" link when too many events
                initialView: 'dayGridMonth',
                views: {
                    dayGrid: {
                      // options apply to dayGridMonth, dayGridWeek, and dayGridDay views
                      titleFormat: { year: 'numeric', month: '2-digit', day: '2-digit' }
                    },
                    timeGrid: {
                      // options apply to timeGridWeek and timeGridDay views
                    },
                    week: {
                      // options apply to dayGridWeek and timeGridWeek views
                    },
                    day: {
                      // options apply to dayGridDay and timeGridDay views
                    }
                  }
            }, o));
            calendar.render();

            $filter.on('changed', function(e, data){
                calendar.refetchEvents();
            });
        
    
    
        });
   };   
})(jQuery, Bajt);

